import React from "react";
import {
  ErrorContainer,
  ErrorMsg,
  GradientContainerRed,
  RetryButton,
} from "./ErrorWrapperStyles";
import {
  MainStore,
  setError,
} from "../../stores/MainStore/MainStore";
import { useUnit } from "effector-react";

const ErrorWrapper: React.FC = () => {
  const { error } = useUnit(MainStore);

  if (error)
    return (
      <ErrorContainer>
        <GradientContainerRed>
          <ErrorMsg>{error}</ErrorMsg>
        </GradientContainerRed>
      </ErrorContainer>
    );

  return <></>;
};

export default ErrorWrapper;
